import React from 'react';
import PropTypes from 'prop-types';
import UserOrder from './UserOrder';
import RichText from '../Prismic/RichText';
import Loading from '../Loading';
import './UserOrders.scss';

const UserOrders = props => {
  if (!props.isSingleOrder && props.orders.length === 0 && !props.primary.emptyOrders) {
    return null;
  }

  const singleOrder = (
    <UserOrder
      country={props.country}
      orderNumber={props.orderNumber}
      userOrders={props.userOrders}
      setUserOrders={props.setUserOrders}
      isSingleOrder
      {...props.primary}
    />
  );

  const multipleOrders = (
    !props.isSingleOrder && props.orders.length > 0 ? (
      props.orders.map(order => (
        <UserOrder
          key={order.id}
          country={props.country}
          currentOrder={order}
          userOrders={props.userOrders}
          setUserOrders={props.setUserOrders}
          isInactiveOrders={props.isInactiveOrders}
          {...props.primary}
        />
      ))
    ) : (
      <RichText
        className="user-orders-empty"
        fields={props.primary.emptyOrders}
      />
    )
  );

  if (props.userOrders.response.pending && !props.isSingleOrder) {
    return (
      <div className="user-orders container-guttered">
        <RichText
          className="user-orders-title"
          fields={props.title}
        />
        <Loading dark relative />
      </div>
    );
  }

  return (
    <div className="user-orders container-guttered">
      <RichText
        className="user-orders-title"
        fields={props.title}
      />
      {props.isSingleOrder ? singleOrder : multipleOrders}
    </div>
  );
};

UserOrders.propTypes = {
  title: PropTypes.array.isRequired,
  primary: PropTypes.shape({
    emptyOrders: PropTypes.array,
  }).isRequired,
  orders: PropTypes.array,
  userOrders: PropTypes.object.isRequired,
  setUserOrders: PropTypes.func.isRequired,
  country: PropTypes.object.isRequired,
  isSingleOrder: PropTypes.bool.isRequired,
  isInactiveOrders: PropTypes.bool,
  orderNumber: PropTypes.string,
};

export default UserOrders;



// WEBPACK FOOTER //
// ./src/client/js/view/components/UserOrders/UserOrders.js